import { Fragment } from "react";

import CustomerCategoryLabel from "./CustomerCategoryLabel";

const CustomerBadge = (props) => {
    if(props.item) {
        return(
            <Fragment>
                {props.item.customerName}
                <CustomerCategoryLabel value={props.item.customerCategory || ""} />
            </Fragment>
        );
    }
    
    return "";
};

export default CustomerBadge;